package ld.scenes;
import pixi.core.renderers.SystemRenderer;
import pixi.core.display.Container;
import pixi.core.graphics.Graphics;
import pixi.core.textures.Texture;
import pixi.core.sprites.Sprite;
import pixi.core.math.shapes.Rectangle;
import pixi.extras.BitmapText;
import pixi.extras.AnimatedSprite;

import stocking.ColoredBitmapText;
import stocking.SceneManager;

import tweenx909.TweenX;
import tweenxcore.color.RgbColor;

import ld.NotificationWindow;
import ld.scenes.MenuScene;
import stocking.AudioManager;
import pixi.core.display.DisplayObject;
import ld.GameState;
import ld.Types.Vec2;
import ld.Types.Faction;
import pixi.core.math.Point;
import ld.Types.LDEventsFile;
import tweenxcore.Tools.Easing;

import ld.scenes.VictoryScene;
import ld.Types.UIClickMode;
import ld.Util;
import ld.GameActionMenu;

import stocking.Scene;

class GameScene extends Scene
{
	var mapData : ld.Types.TiledMap;
	var mapEvents : ld.Types.LDEventsFile;
	var containerPawns : Container;
	public var containerField : Container;
	var containerHud : Container;

	var rgTiles : Map<String,Sprite>;
	var rgTileData : Map<String,Int>;

	var rgPawns : Array<Pawn>;

	var dragMove : Point;
	var dragging = false;

	var TILEWIDTH = 128;
	var TILEHEIGHT = 64;

	var uiClickMode : UIClickMode;

	public var selectedPawn : Pawn;
	public var selectedTarget : Pawn;
	var lastSelectedPawn : Pawn;

	// Hud objects
	var hudSelectedText : BitmapText;
	var hudMonsterPortait : Sprite;
	var hudHumanPortait : Sprite;

	var hudMonsterName : BitmapText;
	var hudMonsterHP : BitmapText;

	public var waterTileIds = new Array<Int>();
	public var blockedTileIds = new Array<Int>();

	var hudHumanName : BitmapText;
	var hudHumanHP : BitmapText;

	var hudTextBox : Sprite;
	var hudAuthorBox : Sprite;
	var hudTextBoxText : BitmapText;
	var hudAuthorBoxText :BitmapText;
	var hudContainerTextBox : Container;
	var btnEndTurn : Container;

	var lastSelectedTile : Vec2 = {x:0, y:0};
	var lastSelectedTileTint : Int = 0xFFFFFF;


	var eventClickCallback : Void->Void;

	public var map : GameMap;

	var actionMenu: GameActionMenu;


	var turnNum : Int = 0;	
	var eventsCallback: Void->Void;

	public var turn : Faction = Monster;

	public function new( renderer : SystemRenderer, stage : Container )
	{
		super( renderer, stage );


		if( ld.GameState.instance.level == null )
			ld.GameState.instance.level = "city2";

		switch(ld.GameState.instance.level)
		{
			case "outskirts1", "outskirts2", "city1":
				strMusicTrack = "assets/music/Industrial Cinematic.mp3";
			case "city2":
				strMusicTrack = "assets/music/Volatile Reaction.mp3";
			default:
				strMusicTrack = "assets/music/River of Io.mp3";
		}

	}

    public override function preload()
    {
		loaderImages = [
			{ filename: "assets/bunny.png"},
			{ filename: "assets/placeholder/debugtiles.png"},
			{ filename: "assets/Forest_Logging_Tiles.png"},
			{ filename: "assets/Urban_Street_Tiles.png"},
			{ filename: "assets/In_Game_Top_Layer.png"},
			{ filename: "assets/In_Game_Low_Layer.png"},
			{ filename: "assets/Small_Button.png"},
			{ filename: "assets/Large_Button.png"},
			{ filename: "assets/Text_Box.png"},

			{ filename: "assets/Bird_Drop_FX.png"},
			{ filename: "assets/Bomv FX.png"},
			{ filename: "assets/Vine FX.png"},
			{ filename: "assets/WHACK FX.png"},
			{ filename: "assets/Bullet_FX.png"},
			
			

		];
		loaderFonts = [
			"assets/khdot16.fnt",
			"assets/khdot12.fnt",
		];
		loaderGifs = [
			//"assets/scene_train_1.gif",
		];
		// @todo switch this to alias model....
		loaderSfx = [
			"assets/sfx/hit01.wav",
			"assets/sfx/hit37.wav",
			"assets/sfx/hit11.wav",
			"assets/sfx/hit09.wav",
			"assets/sfx/MENU B_Select.wav",
			"assets/sfx/MENU A_Select.wav",
			"assets/sfx/MENU B_Back.wav",
			"assets/sfx/Menu Select 1.wav",
			"assets/sfx/Inventory_Open_01.wav",
			"assets/sfx/Inventory_Open_00.wav",
			"assets/sfx/378204__eflexthesounddesigner__semi-auto-rifle-shot-open-field-mixed.wav",	
			"assets/sfx/33245__ljudman__grenade.wav",

		];

		for( i in 0...9)
		{
			loaderSfx.push("assets/sfx/footstep0"+i+".wav");
		}

		loaderData = [
			{ filename: "assets/data/pawns/testpawn.json", alias: "testpawn"},
			{ filename: "assets/data/pawns/testenemy.json", alias: "testenemy"},
			{ filename: "assets/data/pawns/grunt.json", alias: "grunt"},
			{ filename: "assets/data/pawns/heavy.json", alias: "heavy"},
			{ filename: "assets/data/pawns/jetpack.json", alias: "jetpack"},
			{ filename: "assets/data/pawns/officelady.json", alias: "officelady"},
			{ filename: "assets/data/pawns/riot.json", alias: "riot"},

			{ filename: "assets/data/pawns/birdgirl.json", alias: "birdgirl"},
			{ filename: "assets/data/pawns/plantgirl.json", alias: "plantgirl"},
			{ filename: "assets/data/pawns/spidergirl.json", alias: "spidergirl"},
			
		];

		loaderData.push({
			filename: "assets/data/" + ld.GameState.instance.level + ".json",
			alias: ld.GameState.instance.level
		});

		loaderData.push({
			filename: "assets/data/" + ld.GameState.instance.level + "_events.json",
			alias: ld.GameState.instance.level + "_events"
		});

		super.preload();
    }

	public override function enter()
	{
		super.enter();

		uiClickMode = SELECT;

		rgPawns = new Array<Pawn>();

		containerField = new Container();

		if( !dataCache.exists(ld.GameState.instance.level) )
		{
			throw("tried to enter before level loaded. How??");
		}

		mapData = dataCache.get(ld.GameState.instance.level);
		mapEvents = dataCache.get(ld.GameState.instance.level + "_events");

		var containerMap = new Container();

		rgTiles = new Map<String,Sprite>();
		rgTileData = new Map<String,Int>();

		// TEMP: build tile textures
		var rgTileTextures = new Map<Int,Texture>();

		for( tileset in mapData.tilesets )
		{
			if( StringTools.endsWith( tileset.source, "Forest_Logging_Tiles.tsx" ) )
			{
				var tex = Texture.fromImage("assets/Forest_Logging_Tiles.png");
				for( i in 0...(4*9) )
				{
					var offset = 12;
					if( i <= 9 || i == 25 || i == 36 )
						offset = 0;

					if( [28,29,30,31].indexOf(i) != -1 )
					{
						waterTileIds.push(tileset.firstgid + i );
					}

					if( [26].indexOf(i) != -1 )
					{
						blockedTileIds.push(tileset.firstgid + i );
					}

					rgTileTextures[ tileset.firstgid + i ] = new Texture( tex.baseTexture, new Rectangle(128 * ( i % 9),64 * Math.floor( i/9 ) - offset, 128, 64 + offset) );
					
				}

			}

			if( StringTools.endsWith( tileset.source, "Urban_Street_Tiles.tsx" ) )
			{
				var tex = Texture.fromImage("assets/Urban_Street_Tiles.png");
				for( i in 0...(4*5) )
				{
					var offset = 12;
					if( i <= 6 )
						offset = 0;

					if( [9,17].indexOf(i) != -1 )
					{
						blockedTileIds.push(tileset.firstgid + i );
					}


					rgTileTextures[ tileset.firstgid + i ] = new Texture( tex.baseTexture, new Rectangle(128 * ( i % 5),64 * Math.floor( i/5 ) - offset, 128, 64 + offset) );
					
				}

			}

			if( StringTools.endsWith( tileset.source, "ld42debugtiles.tsx" ) )
			{
				var tex = Texture.fromImage("assets/placeholder/debugtiles.png");
				for( i in 0...(2*3) )
				{
					// All debug tiles are blocked now (Only in use for border so :xivshrug:)
					blockedTileIds.push(tileset.firstgid + i );
					
					var offset = 0;
					rgTileTextures[ tileset.firstgid + i ] = new Texture( tex.baseTexture, new Rectangle(128 * ( i % 2),64 * Math.floor( i/2 ) - offset, 128, 64 + offset) );
					
				}

			}
		}


		for( layer in mapData.layers )
		{
			if( layer.chunks == null )
				continue;

			for( chunk in layer.chunks )
			{
				for( x in 0...chunk.width)
				{
					for( y in 0...chunk.height)
					{
						var tileId = chunk.data[ x + y * chunk.height];
						if( tileId == 0 )
							continue;

						var isFlippedHorizontally = ( tileId & 0x80000000 ) != 0 ;
						var isFlippedVertically = ( tileId & 0x40000000 ) != 0;
						//var isFlippedDiagonally = ( tileId & 0x20000000 ) != 0;

						tileId = tileId & 0xFF;

						var tile =  new Sprite(rgTileTextures[tileId ] );

						var absX = x + chunk.x;
						var absY = y + chunk.y;

						var pos = Util.TileToCoord({ x:absX, y:absY });
						tile.x = pos.x;
						tile.y = pos.y;

						tile.anchor.y = 1.0;
						tile.anchor.x = 0;

						if( isFlippedHorizontally )
						{
							tile.anchor.x = 1.0;
							tile.scale.x = -1;
						}

						rgTiles[absX + ":" + absY]=tile;
						rgTileData[absX + ":" + absY] = tileId;
						
						containerMap.addChild(tile);
					}
				}
			}
		}

		map = new GameMap( rgTileData, rgPawns, rgTiles, mapData.width, mapData.height, this );

		/*
		for( x in 0...mapData.width)
		{
			for( y in 0...mapData.height)
			{
				var tile =  new Sprite(Texture.fromImage("assets/placeholder/testile.png"));
				var pos = Util.TileToCoord({ x:x, y:y });
				tile.x = pos.x;
				tile.y = pos.y;

				tile.anchor.y = 1.0;
				tile.anchor.x = 0;

				rgTiles[y*mapData.height + x]=tile;
				
				containerMap.addChild(tile);
			}
		}*/
		

		containerField.addChild( containerMap );

		containerField.interactive = true;

		container.interactive = true;
		container.click = container.tap = function( event : pixi.interaction.InteractionEvent ){
			if( uiClickMode == EVENT )
			{
				if( eventClickCallback != null )
				{
					trace("Clicked! advancing text....");
					eventClickCallback();
				}
			}
		}
		
		containerField.click = containerField.tap = function( event : pixi.interaction.InteractionEvent ) { 
			var mouse = event.data.getLocalPosition(containerField);
			actionMenu.onClick(mouse);
			
			
		};

		containerPawns = new Container();
		

		for( layer in mapData.layers )
		{
			
			if( layer.objects == null )
				continue;

			for( obj in layer.objects)
			{
				
				var pawn = new Pawn(dataCache.get( obj.properties.spawn_type ), rgTileData, this);
				var c = Util.CoordToTile( new Point(obj.x+64, obj.y-64 )  );
				var c = { x: Math.floor( obj.x/64 ), y: Math.floor( obj.y/64)  };
				
				pawn.SetPosition( c );
				
				//pawn.SetPosition( { x: Math.floor(object.x/128), y: Math.floor(object.y/64) } );
				pawn.SetDirection( "NE" );

				rgPawns.push(pawn);

				containerPawns.addChild(pawn.container);

			}

			
	
		}

		containerField.addChild(containerPawns);

		actionMenu = new GameActionMenu(this);

		// Drag events
		containerField.rightdown = containerField.touchstart = onDragStart;
		containerField.rightup = containerField.mouseupoutside = container.touchend = containerField.touchendoutside = onDragEnd;
		containerField.mousemove= containerField.touchmove = onDragMove;
        
		containerField.y = -400;
		containerField.x = 700;
		container.addChild(containerField);

		// HUD
		containerHud = new Container();

		var hudBGSprite = new Sprite( Texture.fromImage("assets/In_Game_Low_Layer.png"));
		containerHud.addChild(hudBGSprite);
		

		hudMonsterPortait = new Sprite( );
		hudHumanPortait = new Sprite();

		//hudMonsterPortait.x = 47;
		hudMonsterPortait.x = 302;
		hudMonsterPortait.y = -44;
		hudMonsterPortait.scale.x = -2.0;
		hudMonsterPortait.scale.y = 2.0;

		hudHumanPortait.x = 978;
		hudHumanPortait.y = -44;
		hudHumanPortait.scale.x = hudHumanPortait.scale.y = 2.0;
		
		containerHud.addChild(hudMonsterPortait);
		containerHud.addChild(hudHumanPortait);

		//

		hudMonsterName = new BitmapText("Plant Girl", { font: "16px khdot16" });
		hudMonsterName.scale.x = hudMonsterName.scale.y = 2;
		hudMonsterName.x = 320;
		hudMonsterName.y = 20;

		hudMonsterHP = new BitmapText("HP: 20/20", { font: "16px khdot16" });
		hudMonsterHP.scale.x = hudMonsterHP.scale.y = 2;
		hudMonsterHP.x = 320;
		hudMonsterHP.y = 60;

		containerHud.addChild(hudMonsterName);
		containerHud.addChild(hudMonsterHP);

		//

		hudHumanName = new BitmapText("Angry Girl", { font: "16px khdot16", align: BitmapTextAlign.RIGHT });
		hudHumanName.scale.x = hudHumanName.scale.y = 2;
		hudHumanName.x = 965;
		hudHumanName.y = 20;
		hudHumanName.anchor.x = 1.0;

		hudHumanHP = new BitmapText("HP: 20/20", { font: "16px khdot16", align: BitmapTextAlign.RIGHT });
		hudHumanHP.scale.x = hudHumanHP.scale.y = 2;
		hudHumanHP.x = 965;
		hudHumanHP.y = 60;
		hudHumanHP.anchor.x = 1.0;

		containerHud.addChild(hudHumanName);
		containerHud.addChild(hudHumanHP);

		
		var hudBGSpriteTop = new Sprite( Texture.fromImage("assets/In_Game_Top_Layer.png"));
		containerHud.addChild(hudBGSpriteTop);


		//End turn
		btnEndTurn = Util.MakeButton( "End Turn");//new BitmapText("==> End Turn", { font: "16px khdot16" });
		btnEndTurn.x = 996;
		btnEndTurn.y = 620;
		btnEndTurn.scale.x = btnEndTurn.scale.y = 2;

		btnEndTurn.interactive = true;
		btnEndTurn.click = btnEndTurn.tap = function( event : pixi.interaction.InteractionEvent ) { 
			if( uiClickMode == EVENT || turn != Monster )
				return;

			AudioManager.instance.play("assets/sfx/MENU A_Select.wav");
			//StartTurn(Human);
			EndPawnTurn();
		};

		containerHud.addChild(btnEndTurn);

		container.addChild(containerHud);

		//

		hudTextBox = new Sprite(Texture.fromImage("assets/Text_Box.png"));
		
		hudTextBox.y = 452;
		hudTextBox.x = 200;

		//

		hudAuthorBoxText = new BitmapText("Author", { font: "16px khdot16" });
		hudAuthorBoxText.scale.x = hudAuthorBoxText.scale.y = 2;
		hudAuthorBoxText.y = 466;
		hudAuthorBoxText.x = 216;
		
		//

		hudTextBoxText = new BitmapText("Hello\nWorld.", { font: "16px khdot16" });
		hudTextBoxText.scale.x = hudTextBoxText.scale.y = 2;
		
		hudTextBoxText.y = 540;
		hudTextBoxText.x = 220;
		
		//

		hudContainerTextBox = new Container();
		containerHud.addChild(actionMenu.container);

		
		hudContainerTextBox.addChild(hudTextBox);

		hudContainerTextBox.addChild(hudAuthorBoxText);
		hudContainerTextBox.addChild(hudTextBoxText);

		hudContainerTextBox.alpha = 0;

		containerHud.addChild(hudContainerTextBox);



		

		StartTurn(Monster);
		
	}

	public function DoVictoryChecks()
	{
		var bEnemiesAlive = false;
		var bAlliesAlive = false;
		for(pawn in rgPawns )
		{
			if(!pawn.isDead() && pawn.getFaction() == Human )
				bEnemiesAlive = true;
			if(!pawn.isDead() && pawn.getFaction() == Monster )
				bAlliesAlive = true;
		}

		if( !bEnemiesAlive )
		{
			// Wahey
			ProcessEvents(function(){
				GameState.instance.completedLevels++;
				SceneManager.instance.transitionToScene(new MapScene(renderer, stage));
			}, "victory");
			
		}

		if( !bAlliesAlive )
		{
			// Booey
			ProcessEvents(function(){
				trace("DED");
				
				SceneManager.instance.transitionToScene(new MapScene(renderer, stage));
			}, "defeat");
			
		}
	}

	function onDragStart( event : pixi.interaction.InteractionEvent )
	{
		 if( uiClickMode == EVENT )
			return;

		dragging = true;
		dragMove = event.data.getLocalPosition(container);
	}

	function onDragEnd( event : pixi.interaction.InteractionEvent )
	{
		dragging = false;
	}
	function onDragMove( event : pixi.interaction.InteractionEvent )
	{
		// Also mouseover!
		if( uiClickMode == EVENT )
			return;
			


		if( !dragging )
		{
			var mouse = event.data.getLocalPosition(containerField);
			var tilepos = Util.CoordToTile(mouse );
			PaintHoverTile( tilepos );

			var target = map.GetPawnForPosition(tilepos);
			selectedTarget = target;

			return;
		}
		
		var change = event.data.getLocalPosition(container); 

		containerField.x += Math.round( change.x - dragMove.x );
		containerField.y += Math.round( change.y - dragMove.y );

		dragMove = change;
	}

	function StartTurn( faction : Faction )
	{
		turn = faction;
		

		ProcessEvents( function(){ TurnHandoff(); });


	}

	function TurnHandoff()
	{
		for( pawn in rgPawns )
		{
			if( pawn.getFaction() == turn )
			{
				pawn.StartTurn();
			}
		}

		if( turn == Human)
			DoEnemyTurn();
		else
		{

			var t = GetActivePlayerPawn();
			if( t != null )
			{
				SelectPawn(t);
			}
		}
	}	

	public function SelectPawn( target: Pawn )
	{
		selectedPawn = target;
		selectedTarget = null;
		CenterOn(target);
		UpdateHud();

	}

	function PawnUnclickHandler( )
	{
		selectedPawn = null;
		hudSelectedText.text = "";
	}

	function UnpaintAllTiles()
	{
		for( x in 0...mapData.width)
		{
			for( y in 0...mapData.height)
			{
				if( !rgTiles.exists(x + ":" + y) )
					continue;

				rgTiles[x + ":" + y].tint = 0xFFFFFF;
			}
		}
	}

	function PaintMoveTilesForPawn( victim : Pawn )
	{
		if( victim == null )
			UnpaintAllTiles();
		else
		{
			
			map.configureForPawn(victim);
			var moveTiles = map.getMoveTargets();	
			

			for( tile in moveTiles )
			{
				if( !rgTiles.exists(tile.x + ":" + tile.y) )
						continue;

				rgTiles[tile.x + ":" + tile.y].tint = 0xFF9999;
			}
		}	
	}

	function PaintAttackTilesForPawn( victim : Pawn )
	{
		for( x in 0...mapData.width)
		{
			for( y in 0...mapData.height)
			{
				if( !rgTiles.exists(x + ":" + y) )
					continue;

				if( victim != null && victim.bCanAttackTile({x:x, y:y}))
					rgTiles[x + ":" + y].tint = 0xFF9999;
				else
					rgTiles[x + ":" + y].tint = 0xFFFFFF;
			}
		}
	}

	function PaintSelectedTilesForPawn( victim : Pawn )
	{
		if( victim != null )
			rgTiles[victim.position.x + ":" + victim.position.y].tint = 0x99FF99;
		else 
		{
			for( x in 0...mapData.width)
			{
				for( y in 0...mapData.height)
				{
					if( !rgTiles.exists(x + ":" + y) )
						continue;

						rgTiles[x + ":" + y].tint = 0xFFFFFF;
				}
			}
		}
	}

	function PaintHoverTile( pos : Vec2 )
	{

		if( rgTiles.exists(lastSelectedTile.x + ":" + lastSelectedTile.y) )
		{
			rgTiles[lastSelectedTile.x + ":" + lastSelectedTile.y].tint = lastSelectedTileTint;
		}

		
		for( x in 0...mapData.width)
		{
			for( y in 0...mapData.height)
			{
				if( !rgTiles.exists(x + ":" + y) )
					continue;

				if( pos.x == x && pos.y == y)
				{
					lastSelectedTileTint =rgTiles[x + ":" + y].tint;
					lastSelectedTile.x = x;
					lastSelectedTile.y = y;
					rgTiles[x + ":" + y].tint = 0x999999;

				}
				
			}
		}
	
	}

	function DoEnemyTurn()
	{

		ProcessAiPawn(rgPawns.copy(), function(){StartTurn(Monster);});

		
	}

	public function ProcessAiPawn( pawns : Array<Pawn>, ?onComplete: Void->Void )
	{
		if( pawns.length == 0 )
		{
			onComplete();
			return;
		}

		var pawn = pawns.shift();

		if( pawn.getFaction() != Human || pawn.isDead() )
		{
			ProcessAiPawn(pawns, onComplete);
			return;
		}

		SelectPawn(pawn);

		hudHumanPortait.texture = Texture.fromImage( pawn.getPortait() );
		CenterOn(pawn);
		map.configureForPawn( pawn );

		// Find the nearest target
		

		var target = null;
		var targetDistance = 9999.0; // @todo scandistance
		for( other in rgPawns )
		{
			if( other.getFaction() != Human && !other.isDead() )
			{
				var path = map.getRouteToPawn(pawn.position, other );
				var distance = (path != null ) ? path.length : 9999;
				if( distance < targetDistance )
				{
					target = other;
					targetDistance = distance;
				}
			}
		}

		if( target == null )
		{
			AfterAiPawnMove(pawn, pawns, onComplete );
			return;
		}

		// FUCK ALL THIS CODE, literally wasted 4 hours writing a bad target seeking algorithm
		// when I could have just written a pathfinder
		
		// So I did.
		
		var path = map.getRouteToPawn(pawn.position, target );
		if( path == null || path.length <= 1 )
		{
			AfterAiPawnMove(pawn, pawns, onComplete );
		}
		else 
		{
			path.pop(); // Remove the last move node, so we're BESIDE the pawn, not on it.
			pawn.moveAlong(path,function(){ AfterAiPawnMove(pawn, pawns, onComplete );});
		}
	

		
	}

	function AfterAiPawnMove(pawn: Pawn, pawns: Array<Pawn>, onComplete: Void->Void )
	{
		// Find the nearest target
		var target = null;
		var targetDistance = 9999.0; // @todo scandistance
		for( other in rgPawns )
		{
			if( other.getFaction() != Human )
			{
				var distance = Math.abs( pawn.position.x - other.position.x ) + Math.abs( pawn.position.y - other.position.y );
				if( distance < targetDistance )
				{
					target = other;
					targetDistance = distance;
				}
			}
		}
		
		var xTarget = target.position.x;
		var yTarget = target.position.y;

		var bCanAbility = pawn.bCanAbilityTile(  {x: xTarget, y: yTarget } );
		var bCanAttack = pawn.bCanAttackTile( {x: xTarget, y: yTarget } );

		trace("Can gun: ", bCanAbility);

		// Are we in ability range?
		if( bCanAbility && !bCanAttack )
		{
			pawn.specialAbility.execute( target.position, function(){
				DoVictoryChecks();
				ProcessAiPawn(pawns, onComplete);
			} );
		}
		else if( bCanAbility && bCanAbility )
		{
			// RANDOMU
			if( Math.random() > 0.6 )
			{
				pawn.specialAbility.execute( target.position, function(){
					DoVictoryChecks();
					ProcessAiPawn(pawns, onComplete);
				} );
			} else {
				pawn.attack( target, function(){
					DoVictoryChecks();
					ProcessAiPawn(pawns, onComplete);
			} );
			}
		}
		else if( pawn.bCanAttackTile( {x: xTarget, y: yTarget } ))
		{
			pawn.attack( target, function(){
				DoVictoryChecks();
				ProcessAiPawn(pawns, onComplete);
			} );
		}
		else 
		{
			DoVictoryChecks();
			ProcessAiPawn(pawns, onComplete);
		}

		
	}


	public function isTileOpen(pos: Vec2)
	{
		for( pawn in rgPawns )
		{
			if( !pawn.isDead() && pawn.position.x == pos.x && pawn.position.y == pos.y )
				return false;
		}

		return true;
	}

	public function UpdateHud()
	{
		hudMonsterPortait.texture = Texture.EMPTY;
		hudHumanPortait.texture = Texture.EMPTY;
		hudMonsterName.text = "";
		hudMonsterHP.text = "";
		hudHumanName.text = "";
		hudHumanHP.text = "";

		var bestMonster = selectedPawn;
		var bestHuman = selectedTarget;

		if( bestMonster != null && bestMonster.getFaction() == Human )
		{
			
			bestHuman = bestMonster;
			bestMonster = null;
			//if( selectedTarget == null )
			//	selectedTarget = selectedPawn;
		}
		
		if( bestMonster != null )
		{
			
				hudMonsterPortait.texture = Texture.fromImage( bestMonster.getPortait() );
				hudMonsterName.text = bestMonster.name;
				hudMonsterHP.text = bestMonster.hp + " / " + bestMonster.getMaxHP();
		}
		if( bestHuman != null )
		{
			hudHumanPortait.texture = Texture.fromImage( bestHuman.getPortait() );		
			hudHumanName.text = bestHuman.name;
			hudHumanHP.text = bestHuman.hp + " / " + bestHuman.getMaxHP();
		}

		
		// Show actions
		actionMenu.show(selectedPawn, uiClickMode);
	}	

	public override function tick( delta : Float )
	{
		// @todo don't do this here.

		UpdateHud();
		
		containerPawns.children.sort( function( a : DisplayObject, b: DisplayObject ) {
		
			return Math.floor( a.position.y - b.position.y );
		});

	}

	/**
	 * @deprecated
	 * @param pos 
	 */
	function GetPawnForPosition( pos : Vec2 )
	{
		for (pawn in rgPawns )
		{
			if( !pawn.isDead() && pawn.position.x == pos.x && pawn.position.y == pos.y)
				return pawn;
		}

		return null;
	}

	public function CenterOn( target : Pawn, ?onComplete: Void->Void )
	{
		
		var pos = Util.TileToCoord( target.position );
		pos.x -= 600;
		pos.y -= 450;


		TweenX.to( containerField, {x: -pos.x, y: -pos.y }).time(0.3).ease(Easing.cubicIn).onFinish(function(){
			if( onComplete != null )
				onComplete();
		});
	}

	
	public function ProcessEvents( ?onComplete: Void->Void, ?addtionalLabel: String)
	{
		eventsCallback = onComplete;
		var turnTrigger = Std.string(turn) + turnNum;
		if( turn == Human )
			turnNum++;
		trace("Starting event queue", turnTrigger);

		for(event in mapEvents.events )
		{
			if( ( (addtionalLabel != null && event.trigger == addtionalLabel ) || event.trigger == "start" || event.trigger == turnTrigger ) && !event.triggered )
			{
				ProcessEventStack( event.actions );
				event.triggered = true;
				uiClickMode = EVENT;
				actionMenu.show(null, uiClickMode);
				return;
			}
		}
		trace("Nothing to do!");

		if( eventsCallback != null )
		{
			eventsCallback();
			eventsCallback = null;
		}
	}

	function ProcessEventStack( events: Array<ld.Types.LDEventsFileAction> )
	{
		eventClickCallback = null;
		if( events == null || events.length == 0 )
		{
			// Return control, frogout.
			uiClickMode = SELECT;

			trace("Finished events queue!");
			if( eventsCallback != null )
				eventsCallback();

			TweenX.to( hudContainerTextBox, {alpha: 0 }).ease(Easing.expoInOut).time(0.4);
			
			return;
		}
		var event = events.shift();

		switch( event.type )
		{
			case "center":
				var target = FindEntityById(event.target);
				if( target == null )
				{
					trace("Tried to fire event but no target exists", event);
				} else {
					CenterOn(target, function() { ProcessEventStack(events); } );
				}
				
			case "dialogue":
				ShowDialog(event.speaker, event.listener, event.text, function() { ProcessEventStack(events); } );
			default:
				trace("???????? Unknown event", event);
				ProcessEventStack(events);

		}
	}

	function ShowDialog(speaker: String, listener: String, text: String, ?onComplete: Void->Void )
	{
		var speakerName = "";
		
		if( speaker != null )
		{
			var target = FindEntityById(speaker, true);
			if( target != null )
			{
				CenterOn(target);
				selectedPawn = target;
				//hudMonsterPortait.texture = Texture.fromImage( target.getPortait() );
				speakerName = target.name;
			}
		} else 
			hudMonsterPortait.texture = Texture.EMPTY;

		if( listener != null )
		{
			var target = FindEntityById(listener);
			if( target != null )
			{
				hudHumanPortait.texture = Texture.fromImage( target.getPortait() );
			}
		} else
			hudHumanPortait.texture= Texture.EMPTY;

		TweenX.to( hudContainerTextBox, {alpha: 0 }).time(0.4).ease(Easing.expoInOut).onFinish(function(){
			hudAuthorBoxText.text = speakerName;
			hudTextBoxText.text = text;

			TweenX.to( hudContainerTextBox, {alpha: 1 }).ease(Easing.expoInOut).time(0.4).onFinish(function(){
				eventClickCallback = onComplete;
			});
		});
		
	}

	function FindEntityById( id : String, ?includeHeroes: Bool )
	{	
		for(pawn in rgPawns )
		{
			if( pawn.getId() == id &&  ( !pawn.isDead() || ( includeHeroes && pawn.isHero() ) ) )
				return pawn;
		}

		return null;
	}

	public function GetActivePlayerPawn()
	{
		var bestPawn : Pawn = null;
		for( pawn in rgPawns )
		{
			if( pawn.getFaction() == Monster && 
				( bestPawn == null ||  bestPawn.getSpeed() < pawn.getSpeed() ) 
				&& !pawn.bFinished )
			{
				bestPawn = pawn;
			}
		}

		return bestPawn;
	}

	function EndPawnTurn()
	{
		
		var pawn = GetActivePlayerPawn();
		trace("ending turn of pawn "+ pawn.name);
		pawn.bFinished = true;

		pawn = GetActivePlayerPawn();
		if( pawn == null )
			StartTurn(Human);
		else
		{
			trace("starting turn of pawn "+ pawn.name);
			SelectPawn(pawn);
		}


	}



}

